import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Align } from '@progress/kendo-angular-popup';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { CommonService } from 'src/app/Service/Common.service';
import { IProjectElementsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { ElementLinkService } from 'src/app/Service/element-link/element-link.service';
import { FormGroup, FormControl } from '@angular/forms';
import { NotificationService } from 'src/app/Service/notification.service';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { result } from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { SearchDialogComponent } from '../search-dialog/search-dialog.component';
import { CommunicationService } from 'src/app/Service/communication/communication.service';
import { IMessageSearchInputModel, IMessageSearchModel, IMsgListInputModel } from 'src/app/ViewModel/CommunicationModel';
@Component({
  selector: 'app-mail-advance-search',
  templateUrl: './mail-advance-search.component.html',
  styleUrls: ['./mail-advance-search.component.css']
})
export class MailAdvanceSearchComponent implements OnInit {

  @Output() advancedSearchStatus: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Input() searchList: any[] = [];
  @Input() tranType:string;

  projectId: number = 0;
  groupId: number = 0;
  memberId: number = 0;
  IsShowPopup = false;
  public inputsearchList!: any[];
  public searchTypeList!: any[];
  public projectElements!: any[];
  public searchGroupList!: any[];
  public searchMailTypeList: any[] = [];
  public anchorElementPopup: any;
  public anchorAlignCenter: Align = { horizontal: 'center', vertical: 'bottom' };
  public popupAlignCenter: Align = { horizontal: 'center', vertical: 'top' };
  public anchorAlignRight: Align = { horizontal: 'right', vertical: 'bottom' };
  public popupAlignRight: Align = { horizontal: 'right', vertical: 'top' };
  public anchorAlignLeft: Align = { horizontal: 'left', vertical: 'bottom' };
  public popupAlignLeft: Align = { horizontal: 'left', vertical: 'top' };
  public margin = { horizontal: -15, vertical: 10 };
  public savedSearchList: IMessageSearchModel[] = [];
  public data: any[]=[];
  public hasSavedSearch: boolean = false;
  public selectedSearchId: number = 0;
  public selectedSearchName!: string | null;
  public selectedTypeIndex: number = -1;
  public selectedTypeValue!: string;
  public clearType: string = '';
  public searchForm: FormGroup = new FormGroup({
    ctrlSearchText: new FormControl(),
    ctrlType: new FormControl()
  });
  constructor(
    private dialog: MatDialog,
    private projService: ProjectInfoService,
    private communicationService: CommunicationService,
    private commonService: CommonService,
    private notificationService: NotificationService,
    public elementLinkService: ElementLinkService,
  ) { }

  ngOnInit() {
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.getSearchTypes();
    this.getSavedSearchList();
    this.hasSavedSearch = this.savedSearchList.length > 0;
  }

  getSearchTypes() {
    this.searchTypeList = [];
    this.searchTypeList.push(
      { value: 0, description: 'Message Number' },
      { value: 1, description: 'Message Subject' }
    );
    this.projService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: 1, IsQueryForStaticElement: false }).subscribe(
      (res: IProjectElementsOutput[]) => {
        this.projectElements = res;
        this.projectElements.forEach(element => {
          if (element.elementDescription != 'Project Code') {
            this.searchTypeList.push({ value: element.elementId, description: element.elementDescription });
          }
        });
        return result;
      });
  }

  // public getMailTypeList() {
  //   let result = this.searchList.map(x => x.messageType);
  //   let filteredResult = result.filter((n, i) => result.indexOf(n) === i);
  //   filteredResult.forEach(x => {
  //     this.searchMailTypeList.push({ value: x, description: x });
  //   })
  // }

  closeAdvanceSearch(event: any) {
    this.advancedSearchStatus.emit(this.searchList);
  }
  public closePopup() {
    this.IsShowPopup = false;
    this.anchorElementPopup = undefined;
  }
  public showInfo(event: any) {
    if (this.hasSavedSearch) {
      this.IsShowPopup = !this.IsShowPopup;
      this.anchorElementPopup = event.target;
    }
  }
  public async searchData() {
    let searchText:string = this.searchForm.controls['ctrlSearchText'].value;
    let type = this.searchForm.controls['ctrlType'].value;
    this.inputsearchList = this.searchList;
    if (searchText != null) {
      if (type != null) {
       // if(this.inputsearchList == undefined || this.inputsearchList?.length<=0)
       // {
          let reqData: IMsgListInputModel = {
            transType: this.tranType,
            projectId: this.projectId,
            groupId: this.groupId,
            memberId: this.memberId,
            messageNoSearchText: type=='Message Number' ? searchText.trim():null,
            messageSubjectSearchText: type!='Message Number' ? searchText.trim():null
          };
          this.inputsearchList = await this.communicationService.GetMessageList(reqData).toPromise()
       // }
        // else
        // {
        //   if (type == 'Message Subject') {
        //     this.inputsearchList = this.inputsearchList.filter(x => x.messageSubject?.toLowerCase().includes(searchText?.toLowerCase()));
        //   }
        //   else if (type == 'Message Number') {
        //     this.inputsearchList = this.inputsearchList.filter(x => x.messageNumber?.toLowerCase().includes(searchText?.toLowerCase()));
        //   }
        //}
      }
      else {
        this.notificationService.showToast("Please Select Type", "Warning");
        return 0;
      }
    }
    this.advancedSearchStatus.emit(this.inputsearchList);
    // this.IsShowPopup = !this.IsShowPopup;
    // this.anchorElementPopup = event.target;
  }

  public clearSearch() {
    this.selectedSearchId = 0;
    this.selectedSearchName = null;
    this.inputsearchList = this.searchList;
    this.searchForm.reset();
    this.clearType = 'Y';
  }

  getSavedSearchList() {
    this.data = [];
    this.communicationService.getMessageSearchList(this.projectId, this.memberId).subscribe((data: any[]) => {
      this.data = data.map(x => {
        let result: IMessageSearchModel = {
          searchId: x.searchId,
          searchName: x.searchName,
          messageNo: x.messageNo,
          messageSubject: x.messageSubject,
          searchText: x.searchText
        };
        return result;
      });
      this.savedSearchList = this.data;
      this.hasSavedSearch = this.savedSearchList.length > 0;
      return result;
    });
  }

  insertSavedSearch() {
    if (this.selectedSearchName != null) {
      this.saveSearch(this.selectedSearchName);
    }
    else {
      let searchText = this.searchForm.controls['ctrlSearchText'].value;
      let type = this.searchForm.controls['ctrlType'].value;
      if (!!searchText && searchText != '' && !!type) {
        const dialogRef = this.dialog.open(SearchDialogComponent, {
          panelClass: 'mat-dialog-secondary',
          width: '35%',
          disableClose:true,
          data: { headerText: 'Save Search Filter As', inputLabel: 'Name' }
        });
        dialogRef.afterClosed().subscribe((res: any) => {
          if (res != '') {
            this.saveSearch(res);
          }
          else {
            this.notificationService.showToast("Search was not saved", "Warning");
          }
        });
      }
      else {
        this.notificationService.showToast("Please give valid input", "Warning");
      }

    }
  }

  saveSearch(searchName: string) {

    let searchText = this.searchForm.controls['ctrlSearchText'].value;
    let type = this.searchForm.controls['ctrlType'].value;
    let inputModel: IMessageSearchInputModel = {
      projectId: this.projectId,
      memberId: this.memberId,
      searchId: this.selectedSearchId,
      searchName: searchName,
      messageNo: type == 'Message Number' ? searchText : null,
      messageSubject: type == 'Message Subject' ? searchText : null,
      searchText: searchText
    };
    this.communicationService.insertMessageSearch(inputModel).subscribe((res: StandardOutputModel) => {
      if (res.successCode == 200) {
        this.notificationService.showToast(res.successMessage, "Success");
        this.searchData();
      }
      else if (res.successCode == 500) {
        this.notificationService.showToast(res.successMessage, "Error");
      }
    });
    this.getSavedSearchList();
    this.hasSavedSearch = this.savedSearchList.length > 0;
  }
  editSavedSearch(data: any) {
    this.selectedSearchId = data.searchId;
    this.selectedSearchName = data.searchName;
    this.searchForm.controls['ctrlSearchText'].setValue(data.searchText);
    if (data.messageNo != null) {
      this.searchForm.controls['ctrlType'].setValue('Message Number');
    }
    if (data.messageSubject != null) {
      this.searchForm.controls['ctrlType'].setValue('Message Subject');
    }
  }
  removeSavedSearch(searchId: number) {
    this.data = [];
    this.notificationService.showPopup('Are you sure you want to delete the selected Filter Option', 'Confirm').then(data => {
      if (data == 'yes') {
        this.communicationService.removeMessageSearch(this.projectId, this.memberId, searchId).subscribe((res: StandardOutputModel) => {
          if (res.successCode == 200) {
            this.notificationService.showToast("Filter option Deleted Successfully", "Success");
          }
          else if (res.successCode == 500) {
            this.notificationService.showToast(res.successMessage, "Error");
          }
          this.getSavedSearchList();
          this.selectedSearchId = 0;
          this.selectedSearchName = null;
          this.hasSavedSearch = this.savedSearchList.length > 0;
        });
      }
    });
  }
}
